<!-- @format -->
<template>
    <div class="gst-booking-confirmed d-flex">
        <div class="gst-booking-confirmed__reservation d-flex flex-column col-12 col-md-5 pa-0">
            <HotelReservationInfo
                :class="isPastBooking && 'gst-hotel-reservation-info-disable'"
                :currency="booking.currency"
                :hotel-rating="bookingHotelRoom.award"
                :hotel-name="bookingHotelRoom.name"
                :hotel-image="bookingHotelRoom.image"
                :hotel-address="bookingHotelRoom.address"
                :hotel-accommodation="bookingHotel.accommodation"
                :hotel-room-rate="bookingHotel.basePrice"
                :hotel-supplier-confirmation-number="bookingHotel.supplierConfirmationNumber"
                has-hotel-reservation-only />
            <EarnBanner
                v-if="userIsAuth"
                :points="booking.pointsEarned"
                class="gst-booking-confirmed__reservation-earn-banner">
                <template #default="{ points }">
                    <div
                        class="gst-order-confirmation_earn-banner-content d-flex flex-column align-center">
                        <span class="gst-order-confirmation_earn-banner-content_title">{{
                            $t(
                                'shared:components.bonusPoints.bonusPointsCartCheckoutConfirmation.title'
                            )
                        }}</span>
                        <span class="gst-order-confirmation_earn-banner-content_points">{{
                            $t(
                                'shared:components.bonusPoints.bonusPointsCartCheckoutConfirmation.pointWithCount',
                                { count: booking.pointsEarned, formattedCount: points }
                            )
                        }}</span>
                    </div>
                </template>
            </EarnBanner>
        </div>
        <div class="col-12 col-md-7 pa-0">
            <GuestReservationInfo
                :class="isPastBooking && 'gst-guest-disable'"
                :billing-details="booking.billingDetails"
                :hotel-meal-plan="mealPlan"
                :hotel-room-type="roomType"
                :hotel-nights-count="nightsCount"
                :hotel-rooms-count="roomsCount"
                :hotel-adults-count="adultsCount"
                :hotel-children-count="childrenCount"
                :hotel-checkin="checkinDate"
                :hotel-checkout="checkoutDate"
                :hotel-checkin-time="checkInTime"
                :hotel-checkout-time="checkOutTime" />
            <slot name="payment-summary"></slot>
            <slot name="cancellation-policy"></slot>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import GuestReservationInfo from '@tenant/app/modules/hotel/features/manageBooking/_components/GuestReservationInfo.vue';
import HotelReservationInfo from '@tenant/app/modules/order/components/HotelReservationInfo.vue';
import EarnBanner from '@tenant/app/components/banner/EarnBanner.vue';

export default {
    name: 'BookingContentStatusConfirmed',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking.theManageBooking.bookingContent.confirmed',
    },
    components: {
        GuestReservationInfo,
        HotelReservationInfo,
        EarnBanner,
    },
    computed: {
        ...mapGetters({
            userIsAuth: 'user/isAuth',
            booking: 'booking/get',
            bookingHotel: 'booking/getHotel',
            bookingHotelRoom: 'booking/getRoom',
            isPastBooking: 'booking/isPastBooking',
        }),
        mealPlan() {
            return this.bookingHotelRoom.room.rate.mealPlan;
        },
        roomType() {
            return this.bookingHotelRoom.room.name;
        },
        nightsCount() {
            return this.bookingHotel.accommodation.nights;
        },
        roomsCount() {
            return this.bookingHotel.accommodation.roomsCount;
        },
        adultsCount() {
            return this.bookingHotel.accommodation.guests.adultsCount;
        },
        childrenCount() {
            return this.bookingHotel.accommodation.guests.childrenCount;
        },
        checkinDate() {
            return this.bookingHotel.accommodation.startDateTime;
        },
        checkoutDate() {
            return this.bookingHotel.accommodation.endDateTime;
        },
        checkInTime() {
            return this.bookingHotelRoom.policy.checkInDateTime;
        },
        checkOutTime() {
            return this.bookingHotelRoom.policy.checkOutDateTime;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

.gst-hotel-reservation-info-disable,
.gst-guest-disable {
    opacity: 0.6;
}

.gst-booking-confirmed__reservation {
    gap: theme-spacing(4);

    @include desktop-only {
        gap: theme-spacing(6);
    }

    .gst-booking-confirmed__reservation-earn-banner {
        border: 1px solid theme-color('septenary');
    }
}

@include mobile-only {
    .gst-booking-confirmed {
        ::v-deep .gst-hotel-reservation-info .image-container img {
            max-height: 185px !important;
        }
    }

    .gst-booking-confirmed__reservation-earn-banner {
        border: 1px solid theme-color('septenary');
    }
}
</style>
